import { formatPattern } from "react-router-utils";
import { stringify } from "app/helpers/datauri";
import ImmutablePropTypes from "react-immutable-proptypes";
import Link from "app/components/UI/Link";
import List from "app/components/UI/List";
import PropTypes from "prop-types";
import React from "react";

export const ArticleListItem = ({ translate, clubId, intl, onDeleteArticle, article, product }) => {
  const image = product.getIn(["publicMetadata", "imagePath"]);
  const imagePath = image ? image.toJS() : "";

  return (
    <List.Item
      title={
        <Link
          to={formatPattern("/:clubId/shop/:productId", {
            clubId: clubId,
            productId: product.get("@id")
          })}
        >
          {product.getIn(["publicMetadata", "title"])}
        </Link>
      }
      subtitle={product.getIn(["publicMetadata", "subTitle"])}
      right={intl.formatNumber(article.get("priceTI") / 100, {
        style: "currency",
        currency: "EUR"
      })}
      mediaUrl={imagePath ? stringify(imagePath) : null}
      mediaName={product.getIn(["publicMetadata", "title"])}
      onAction={() => onDeleteArticle(article.get("@id"))}
      labelAction={translate("Supprimer")}
    />
  );
};

ArticleListItem.propTypes = {
  translate: PropTypes.func.isRequired,
  onDeleteArticle: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  article: ImmutablePropTypes.map.isRequired,
  product: ImmutablePropTypes.map.isRequired
};

export default ArticleListItem;



// WEBPACK FOOTER //
// ./src/app/components/ArticleListItem/ArticleListItem.js